export default __webpack_public_path__ + "static/media/i052vp.6921a57e.webp";